import { render, staticRenderFns } from "./historyYCfList.vue?vue&type=template&id=1cf57abc&"
import script from "./historyYCfList.vue?vue&type=script&lang=js&"
export * from "./historyYCfList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports